import type { FC } from 'react';
import { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import ModuleLoaderLazy from '@wix/da-shared-react/pkg/Discord/redux/ModuleLoaderLazy';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';

const DiscordTip = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "discord" */
        './index'
      )
  )
);

export interface Props {}

const DiscordTipLoadable: FC<Props> = () => {
  // Suspense can't render in SSR
  const mounted = useIsMounted();
  if (!mounted) {
    return null;
  }
  return (
    <ErrorBoundary debugComponent="DiscordTipLoadable">
      <Suspense fallback={null}>
        <ModuleLoaderLazy />
        <DiscordTip />
      </Suspense>
    </ErrorBoundary>
  );
};
DiscordTipLoadable.displayName = 'DiscordTipLoadable';

export default DiscordTipLoadable;
